import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card } from 'react-bootstrap';
import RegisterLocationForm from 'components/LocationForm/RegisterLocationForm';
import EditGroupLocationForm from 'components/LocationForm/EditGroupLocationForm';
import Button from 'components/DesignSystem/Button';
import InteractiveMap from 'components/InteractiveMap';
import RegisterMobile from 'components/Meteorology/Agro/Register/Mobile';
import useIsMobile from 'utils/hooks/useIsMobile';
import useLocationMarkers from 'hooks/Meteorology/Agro/useLocationMarkers';
import { store } from 'redux/store';
import {
  setCreateAlert,
  setEditAlert,
  selectMeteorologyAgroGroupLocationCreateAlert,
  selectMeteorologyAgroGroupLocationEditAlert,
} from 'redux/reducers/meteorologyAgroGroupLocationFeedbackReducer';
import { setCurrentTab } from 'redux/reducers/agroLayoutReducer';
import useLocationGroups from 'hooks/Meteorology/Agro/useLocationGroups';
import useLocations from 'hooks/Meteorology/Agro/useLocations';
import useUpdateLocationGroup from 'hooks/Meteorology/Agro/useUpdateLocationGroup';
import useUpdateLocation from 'hooks/Meteorology/Agro/useUpdateLocation';
import useDeleteLocationGroup from 'hooks/Meteorology/Agro/useDeleteLocationGroup';
import useDeleteLocation from 'hooks/Meteorology/Agro/useDeleteLocation';
import useSaveLocationGroup from 'hooks/Meteorology/Agro/useSaveLocationGroup';
import useCities from 'hooks/Meteorology/Agro/useCities';

import BrazilStatesLayer from 'components/Meteorology/Agro/BrazilStatesLayer';
import useAgroSaveLocationParams from 'hooks/Meteorology/Agro/RegisterForm/useAgroSaveLocationParams';

const ESRI_TILE_URL = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';
const ESRI_TILE_ATTRIBUTION = 'Tiles &copy; Esri';

export default function Register() {
  const isMobile = useIsMobile();
  const [registering, setRegistering] = useState(false);
  const [editing, setEditing] = useState(false);

  const { groups } = useLocationGroups();
  const { locations } = useLocations();
  const { cities } = useCities();
  const { deleteGroup } = useDeleteLocationGroup();
  const { deleteLocation } = useDeleteLocation();
  const { updateGroup } = useUpdateLocationGroup();
  const { updateLocation } = useUpdateLocation();

  const {
    saveGroup,
  } = useSaveLocationGroup();

  const {
    saveLocationParams,
  } = useAgroSaveLocationParams();

  const alertEdit = useSelector(selectMeteorologyAgroGroupLocationEditAlert);
  const alertRegister = useSelector(selectMeteorologyAgroGroupLocationCreateAlert);

  const onRegisterHide = useCallback(() => {
    setRegistering(false);
    store.dispatch(setCreateAlert(undefined));
  }, []);
  const onEditHide = useCallback(() => {
    setEditing(false);
    store.dispatch(setEditAlert(undefined));
  }, []);

  const locationMarkers = useLocationMarkers();

  useEffect(() => {
    store.dispatch(setCurrentTab('register'));
  }, []);

  if (isMobile) {
    return <RegisterMobile />;
  }

  return (
    <div>
      <Card className="shadow-sm forecast-instruction-card m-5 p-4">
        <div className="d-flex justify-content-end flex-row gap-1">
          <Button icon="add" onClick={() => setRegistering(true)}>Cadastrar</Button>
          <Button type="secondary" icon="edit" onClick={() => setEditing(true)}>Editar</Button>
        </div>
        <div className="d-flex flex-row justify-content-center m-3">
          <div className="w-50 z-2">
            <InteractiveMap
              markers={locationMarkers}
              tileUrl={ESRI_TILE_URL}
              tileAttribution={ESRI_TILE_ATTRIBUTION}
            >
              <BrazilStatesLayer />
            </InteractiveMap>
          </div>
        </div>
      </Card>
      <RegisterLocationForm
        show={registering}
        onHide={onRegisterHide}
        alert={alertRegister}
        groups={groups}
        saveGroup={saveGroup}
        saveLocationParams={saveLocationParams}
        cities={cities}
      />
      <EditGroupLocationForm
        show={editing}
        onHide={onEditHide}
        groups={groups}
        locations={locations}
        deleteGroup={deleteGroup}
        deleteLocation={deleteLocation}
        updateGroup={updateGroup}
        updateLocation={updateLocation}
        alert={alertEdit}
      />
    </div>
  );
}
